// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"16":"65af593e","553":"b7f0ca23","624":"62591c1c","787":"a0a63c57"}[chunkId] + ".chunk.js";
};